module.exports = __webpack_public_path__ + "static/media/pastoral-smart.06d649f7.svg";